<app-content-header 

    [hideBreadcrumb]="true"
    [class]="'py-3'" [hasBgImage]="true"
    [target]="'hierarchy'"></app-content-header>

<div fxLayout="row wrap" fxLayoutAlign="center" class="p-2">
    <div fxFlex="100" class="p-2">
    </div>
</div>
<div fxLayout="row wrap" fxLayoutAlign="center" class="p-2">
    <div  class="p-2" style="width: 100%;">
      <mat-card *ngFor="let department of departments" style="width: 25%;" [style.float]="'float' | translate" (click)="editDepartment(department)">
        <mat-card-header fxLayoutAlign="center">
            <mat-icon >tab</mat-icon>
        </mat-card-header>
        <mat-card-content fxLayout="column" fxLayoutAlign="center">
           
                <h3  fxLayoutAlign="center">  &nbsp;{{ department.designation}}</h3>
                
        </mat-card-content>
    </mat-card>

    <mat-card  style="width: 25%;" [style.float]="'float' | translate">
        <mat-card-header fxLayoutAlign="center" *ngIf="!show_form">
            <mat-icon (click)="showNewDepartmentForm()">add</mat-icon>
        </mat-card-header>
        <mat-card-content fxLayout="column" fxLayoutAlign="center" *ngIf="show_form">
           
            <form fxLayout="column" fxLayoutAlign="center" [formGroup]="form" (ngSubmit)="save()">
                <mat-form-field>
                    <input matInput placeholder="{{'designation' | translate}}"
                        [(ngModel)]="new_department.designation" required [formControlName]="'designation'">
                    <mat-hint></mat-hint>
                   
                </mat-form-field>

                <mat-form-field>
                    <input matInput placeholder="{{'abbreviation' | translate}}"
                        [(ngModel)]="new_department.abbreviation" required [formControlName]="'abbreviation'">
                    <mat-hint></mat-hint>
                  
                </mat-form-field>
                <div fxFlex="100">
                    <button mat-raised-button color="primary" fxFlex="50" class="mat-elevation-z6 w-50 mt-3 mr-1" type="submit">{{'buttons.save' | translate}}</button>
                    <button mat-raised-button color="secondary" (click)="cancel()"  fxFlex="50" class="mat-elevation-z6 w-50 mt-3 ml-1" >{{'buttons.cancel' | translate}}</button>
         
                </div>

              
            </form>
                
        </mat-card-content>
    </mat-card>
    </div>
   
</div>